import { useEffect, useState } from "react";
import { Loading } from "notiflix";
import { Report } from "notiflix/build/notiflix-report-aio";
import { useParams } from "react-router-dom";
import Sidebar from "../components/layout/sidebar/sidebar";
import { MainView } from "../components/layout/main";
import { Page, PageHeader } from "../ui";
import api from "../helpers/apiRequester";
import { getLoginUrl } from "../helpers/authConfig";
import { ClientView } from "../components/views/singleClientView";
import { CaseView } from "../components/views/caseViewContainer";

function ViewCase() {
    const [caseData, setCaseData] = useState<any>();
    const [clientData, setClientData] = useState<any>();
    const [caseRef, setCaseRef] = useState<string>("");
    const { url_case_ref } = useParams();

    useEffect(() => {
        if (url_case_ref && caseRef == "") {
            setCaseRef(url_case_ref);
            Loading.circle("Loading...");
            // console.log("LOADING.... GET CASE DATA");
            getData(url_case_ref);
        }
    }, [caseRef]);

    const getData = async (url_case_ref: string) => {
        try {
            // console.log("CASEREF: ", url_case_ref);

            const apiResponse = await api({
                url: "view-case",
                data: { case_ref: url_case_ref },
            });
            const data = apiResponse.data;

            if (data.success) {
                setCaseData(data.caseInfo);
                setClientData(data.clientInfo);
            }

            // console.log("CASE DATA: ", data);
            Loading.remove();
        } catch (error: any) {
            console.log(error);
            Loading.remove();
            if (error?.response.status == 401) {
                Report.failure("Session Timed Out", "Please log in again to continue.", "Okay", () => {
                    window.location.href = getLoginUrl();
                });
            } else {
                console.log("error getting data from api....");
                // window.location.href = getLoginUrl();
            }
        }
    };

    return (
        <div className="viewCase">
            <Sidebar />
            <MainView>
                <Page>
                    <PageHeader eyebrow="Case" title={caseRef} backTo="/cases" backLabel="All cases" />
                    {clientData ? <ClientView data={clientData} /> : null}
                    {caseData ? <CaseView data={caseData} /> : null}
                </Page>
            </MainView>
        </div>
    );
}

export default ViewCase;
